  function handleTextareaKeyUp(textarea) {
    var textareaValue = $(textarea).val().trim();
    console.log(textareaValue, "hhh");

    if (textareaValue === "") {
      alert("hii");
    } else {
      alert("bye");
      
      $('input.metas-4').val(textareaValue);
      console.log('Updated value:', $('input.metas-4').val());
    }
  }




$(document).ready(function(){
    $('.pickup-and-cake').click(function(){
      $('.pickup-and-cake').not(this).removeClass('expand').children('p').slideUp();
      $(this).toggleClass('expand').children('p').slideToggle();
    });
  });
$('.color_swaches_color').click(function(){
     $('.color_swaches_color').removeClass("border_class");
    $(this).addClass("border_class")
});


$('.palette_img').click(function(){
  $('.palette_img').removeClass("border_active")
    $(this).addClass("border_active")
});



// $(document).ready(function () {
//     var selectedValue = $('.input').val();
// console.log(selectedValue)
//     if (selectedValue == "heart") {
//         $('.product__color-chips.dynamic-variant-input-wrap button').each(function () {
//             var value = $(this).attr('data-option-value');
// console.log(value)
//             if (value == '4 inch / serves 2-4') {
//                 $(this).css("cursor", "not-allowed");
//             }
//         });
//     }
// });





// $(document).ready(function() {
//     $('.palette_img').on('click', function() {
//         var image = this;

//         var colorThief = new ColorThief();

//         var colorPalette = colorThief.getPalette(image, 5);

//         // Find the closest .paltte_images and then find the .colorPaletteContainer within it
//         var container = $(this).closest('.color-images').find('.colorPaletteContainer');
//         displayColorPalette(colorPalette, container);
//     });

//     function displayColorPalette(palette, container) {
//         container.empty();

//         for (var i = 0; i < palette.length; i++) {
           
//             var colorBox = $('<div class="colorBox"></div>');
//             colorBox.css('background-color', 'rgb(' + palette[i].join(',') + ')');
//             container.append(colorBox);

            
//             var colorValue = 'rgb(' + palette[i].join(',') + ')';

           
//             var messageDiv = $('<div class="message"></div>');
//             messageDiv.text("Color copied to clipboard:\n" + colorValue);

            
//             container.append(messageDiv);

          
//             copyColorToClipboard(colorValue);
//         }
//     }

//     function copyColorToClipboard(colorValue) {
//         navigator.clipboard.writeText(colorValue).then(function() {
//             console.log("Color copied to clipboard:", colorValue);
//         }).catch(function(err) {
//             console.error('Unable to copy color to clipboard', err);
//         });
//     }
// });






// $(document).ready(function() {
//     $('.palette_img').on('click', function() {
//         var image = this;

//         var colorThief = new ColorThief();

//         var colorPalette = colorThief.getPalette(image, 5);

//         var container = $(this).closest('.color-images').find('.colorPaletteContainer');
//         displayColorPalette(colorPalette, container);
//     });

//     function displayColorPalette(palette, container) {
//         container.empty();

//         for (var i = 0; i < palette.length; i++) {
//             var colorBox = $('<div class="colorBox"></div>');
//             var rgbValues = palette[i].join(',');
//             colorBox.css('background-color', 'rgb(' + rgbValues + ')');
//             container.append(colorBox);

//             getColorNameFromAPI(rgbValues, container);
//         }
//     }

//     function getColorNameFromAPI(rgbValues, container) {
//         $.ajax({
//             url: 'https://www.thecolorapi.com/id?rgb=' + rgbValues,
//             method: 'GET',
//             success: function(data) {
//                 var colorName = data.name.value;
//                 var messageDiv = $('<div class="message"></div>');
//                 messageDiv.text("Color: " + colorName);

//                 container.append(messageDiv);
//             },
//             error: function(err) {
//                 console.error('Error fetching color name:', err);
//             }
//         });
//     }
// });


// $(document).ready(function() {
//     $('.palette_img').on('click', function() {
//         var image = this;

//         var colorThief = new ColorThief();

//         var colorPalette = colorThief.getPalette(image, 5);

//         var container = $(this).closest('.color-images').find('.colorPaletteContainer');
//         displayColorPalette(colorPalette, container);
//     });

//     function displayColorPalette(palette, container) {
//         container.empty();

//         for (var i = 0; i < palette.length; i++) {
//             var colorBox = $('<div class="colorBox"></div>');
//             var rgbValues = palette[i].join(',');
//             colorBox.css('background-color', 'rgb(' + rgbValues + ')');

//             // Add data attribute to store color name
//             colorBox.data('colorName', '');
            
//             container.append(colorBox);

//             getColorNameFromAPI(rgbValues, colorBox);
//         }
//     }

//     function getColorNameFromAPI(rgbValues, colorBox) {
//         $.ajax({
//             url: 'https://www.thecolorapi.com/id?rgb=' + rgbValues,
//             method: 'GET',
//             success: function(data) {
//                 var colorName = data.name.value;
//                 colorBox.data('colorName', colorName);

//                 // Set the color name as the value attribute
//                 colorBox.attr('value', colorName);

//                 var messageDiv = $('<div class="message"></div>');
//                 messageDiv.text("Color: " + colorName);

//                 container.append(messageDiv);
//             },
//             error: function(err) {
//                 console.error('Error fetching color name:', err);
//             }
//         });
//     }
// });


// $('.colorPaletteContainer').on('click', '.colorBox', function() {
//     var new_val = $(this).data('colorName');
//     console.log(new_val);

//     $('.valcolor').text(new_val);
// });
// $(document).ready(function () {
//     $('.combined-option').mouseenter(function () {
//         var value = $(this).attr('value');
//         $('.hide_color1').text(value);
//     });

//     $('.combined-option').mouseleave(function () {
//         // You can add some behavior here if needed when the mouse leaves the element
//         // For example, clearing the text in '.hide_color1'
//         $('.hide_color1').text("");
//     });
// });


$(document).ready(function () {
    $('.combined-option').mouseenter(function () {
        var value = $(this).attr('value');
        $(this).find('.hide_color1').text(value);
    });

    $('.combined-option').mouseleave(function () {
        // You can add some behavior here if needed when the mouse leaves the element
        // For example, clearing the text in '.hide_color1'
        $(this).find('.hide_color1').text("");
    });
});


$('.font-options').click(function(){
    $('.select_option_1').toggleClass("display_active");
});


$('.select_option_1 li').click(function(){
   $('.select_option_1 li').removeClass("active_backgound");
    $(this).addClass("active_backgound")
});

$('.select_option_1 li').click(function () {
    var val_cap = $(this).text();
    $('.emty_div').text(val_cap)
})
